import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "avatar-container" }
const _hoisted_2 = { class: "avatar-circle" }
const _hoisted_3 = { class: "avatar-right" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "col mleft-04 mtop-08"
}

import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'esConsultationDetails',
  props: {
    doctorName: {},
    secondaryHealthProName: {},
    initial: {},
    instituteName: {},
    displayImportBy: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: "bg-modal w-maxC",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.initial), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.secondaryHealthProName)
            ? (_openBlock(), _createBlock(_component_text_item, {
                key: 0,
                txt: _unref(t)('patient.expression.doctor.for'),
                class: "dr-institute mright-04 txt-grey-64"
              }, null, 8, ["txt"]))
            : (_ctx.displayImportBy)
              ? (_openBlock(), _createBlock(_component_text_item, {
                  key: 1,
                  txt: _unref(t)('patient.expression.doctor.importedFor'),
                  class: "dr-institute mright-04 txt-grey-64"
                }, null, 8, ["txt"]))
              : _createCommentVNode("", true),
          _createVNode(_component_text_item, {
            txt: _ctx.doctorName,
            class: "dr-name"
          }, null, 8, ["txt"])
        ]),
        _createVNode(_component_text_item, {
          txt: _ctx.instituteName,
          class: "dr-institute txt-grey-64"
        }, null, 8, ["txt"])
      ])
    ]),
    (_ctx.secondaryHealthProName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_text_item, {
            txt: _unref(t)('patient.expression.doctor.by', {secondaryHealthPro: _ctx.secondaryHealthProName}),
            class: "font-size-12",
            styles: "main-m"
          }, null, 8, ["txt"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})